export const SIDEBAR_CLOSE_EVENT = 'sidebar-close';
export const SIDEBAR_OPEN_EVENT = 'sidebar-open';
export const SIDEBAR_CHANGE_STATUS_EVENT = 'sidebar-change-status';
